<template>
    <div>

        <v-layout row justify-center>
            <v-dialog  v-model="mustShowMultipleTestsPopup"  persistent max-width="50%" class="popup-scoring" id="close-upload-popup">


                <v-card class="popup-scoring">
                    <v-card-title class="headline">
                        <span v-if="!mustShowMultipleProgressMultiple" class="font-weight-light">{{text("api.pro.tests.uploadMultiple")}}</span>
                        <span v-if="mustShowMultipleProgressMultiple" class="font-weight-light">{{text("api.pro.tests.downloadZip")}}</span>
                        <span v-if="!mustShowMultipleProgressMultiple" @click="hideTestPopup()" class="float-right"><v-icon class="font-weight-light">clear</v-icon></span>
                    </v-card-title>

                    <v-card-text >
                        <input v-if="!mustShowMultipleProgressMultiple" type="file" ref="file" @change="onFileSelected">
                        <br /><br />
                                <div v-if="testRunDetails">
                                    <div>
                                        <span class="infoDetails" v-if="testRunDetails.productCode" v-html="testRunDetails.productCode"></span>
                                    </div>
                                    <div>
                                        <span class="infoDetails" v-html="testRunDetails.applicationUrl"></span>
                                    </div>
                                    <div>
                                        <span v-html="testRunDetails.username"></span>
                                    </div>
                                </div>
                        <div v-if="mustShowMultipleProgressMultiple">
                            <v-progress-linear
                                :indeterminate="true"
                                color="primary"
                                height="10">
                            </v-progress-linear>
                            <span>{{text("api.pro.tests.downloading")}}</span>
                        </div>

                    </v-card-text>
                    <v-card-actions v-if="!mustShowMultipleProgressMultiple">
                        <v-spacer></v-spacer>
                        <v-btn @click="onUploadMultipleTests" class="btn-test-pg" :disabled="!uploadTrue">{{text("api.button.ok")}}</v-btn>
                        <v-btn @click="hideTestPopup()">{{ text('api.button.cancel') }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
        name: 'MultipleTestsPopup',
        data () {
            return {
                selectedFile: null,
                uploadTrue: false
            }
        },
        computed: {
            ...mapGetters({
                mustShowMultipleTestsPopup: 'TestStore/getMustShowMultipleTestsPopup',
                //testTree: 'TestStore/getTestTree',
                mustShowMultipleProgressMultiple: 'TestStore/getProgressMultiple',
                testRunDetails: 'TestStore/getTestRunDetails'
            }),
        },
        methods: {
            ...mapActions({
                showMultipleTestsPopup: 'TestStore/showMultipleTestsPopup'
            }),

            hideTestPopup() {
                this.$store.commit('TestStore/setMustShowMultipleTestsPopup', false);
            },
            escapeKeyListener: function(evt) {
                if (evt.keyCode === 27) {
                    /**
                     * remove posibility to close popup if progress bar is active
                    */
                    if(this.mustShowMultipleProgressMultiple === true) {

                    } else {
                        this.hideTestPopup();
                    }

                }
            },
            onFileSelected: function (event) {
                this.selectedFile = event.target.files[0];
                this.uploadTrue = event.target.files.length === 1;
            },
            onUploadMultipleTests() {

                this.$store.commit('TestStore/setGetProgressMultiple', true);

                this.$store.dispatch('TestStore/multipleUploadAndDownload', {
                    file: this.selectedFile
                })
                .then(() => {
                    this.hideTestPopup();
                });

            }

        },
        created: function() {
            document.addEventListener('keyup', this.escapeKeyListener);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.escapeKeyListener);
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .popup-scoring {

        &.card {
            padding: 0;

            .card__title {
                background-color: $color-brand-primary;
                display: block;
                padding: 20px 40px;

                .icon {

                    &:hover {
                        cursor: pointer;
                    }

                }
            }

            .card__text {
                padding: 40px;
            }

            .card__actions {
                padding: 15px 40px;
            }

        }

        p {
            font-size: $font-size-small;
            color: $color-headings-text;
            margin-bottom: 0;
        }

        .ambulance-scoring {
            position: relative;
            top: 7px;
            right: 7px;
        }
    }

    .infoDetails {
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/professional/components/tests/UploadMultipleTestsPopup.vue